module.exports = __webpack_public_path__ + "img/savology-screen-8.cb682581.png";